import { Component, OnInit,TemplateRef,ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CONFIGCONSTANTS } from '../../../../config/app-constants';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { DashboardService } from '../../../../_services/dashboard.service';
import { first } from 'rxjs/operators';
import { LoaderService } from '../../../../_services/loader.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-orders-extended-modal',
  templateUrl: './orders-extended-modal.component.html',
  styleUrls: ['./orders-extended-modal.component.scss']
})
export class OrdersExtendedModalComponent implements OnInit {

  @ViewChild(DatatableComponent, { static: false }) datatable: DatatableComponent;

  // Get datatble configuration -- start
  loadingIndicator = false;
  getSuccessResult= false;
  reorderable = CONFIGCONSTANTS.datatableConfig.reorderable;
  scrollbarH = CONFIGCONSTANTS.datatableConfig.scrollbarH;
  serverSorting = CONFIGCONSTANTS.datatableConfig.serverSorting;
  serverPaging = false;
  piningRight = CONFIGCONSTANTS.datatableConfig.piningRight;
  headerHeight = CONFIGCONSTANTS.datatableConfig.headerHeight;
  footerHeight = CONFIGCONSTANTS.datatableConfig.footerHeight;
  rowHeight = CONFIGCONSTANTS.datatableConfig.rowHeight;
  limitList: any[] = CONFIGCONSTANTS.datatableConfig.limitList;
  ColumnMode = ColumnMode;
  totalReords = CONFIGCONSTANTS.datatableConfig.page.totalReords;
  pageNumber = CONFIGCONSTANTS.datatableConfig.page.pageNumber;
  // size = CONFIGCONSTANTS.datatableConfig.page.size;
  size = 50;
  dtMessages = CONFIGCONSTANTS.datatableConfig.dtMessages;
  // Get datatble configuration -- end
  momentDateTime24Format = CONFIGCONSTANTS.momentDateTime24Format || 'MM/DD/YYYY hh:mm:ss';
  momentDateFormat = CONFIGCONSTANTS.momentDateFormat || 'MM/DD/YYYY';
  readonly noColumnRecordText = CONFIGCONSTANTS["dataTableListing"]["columnRecordMissingText"];

  public extendedOrdersData=[];
  public uuid:any;
  public filter:any;
  public highestValueFilter:string = 'month';
  sortParam = 'created_at';
  sortOrder = 'desc';

  //Export Report
  excelIconURL:string = 'assets/img/excel-icon.png';
  csvIconURL:string = 'assets/img/csv-icon.png';
  reportIconSvgURL:string = 'assets/img/report-icon.svg';
  csvClicked = true;
  excelClicked = false;
  reportType:string = 'default';
  exportType:string = 'csv';
  req:any;
  pharmId:any;
  fileName;

  constructor(
    public modalRef: BsModalRef,
    public modalRefExport: BsModalRef,
    private dashService: DashboardService,
    private modalService: BsModalService,
    private loader: LoaderService
  ) { }

  ngOnInit() {
    this.getExtendedOrdersData();
    let date = new Date();
    let fullDate = date.getDate()+ "-" + (date.getMonth()+1) + "-" + date.getFullYear();
    this.fileName = `Medify_${this.pharmId}_Highest Value Patients_${fullDate}`;
  }

  /** Get status class from configuration
  * @param status Active/Inactive/Penging
  */
   public getStatusClass(status) {
     if (status) {
       return CONFIGCONSTANTS.statusClass[status];
     } else {
       return 'badge-primary';
     }
   }
   /**
    * Sort datatable fields
    * @param event event was triggered, start sort sequence
    */
   public onSort(event) {
     this.sortParam = event.sorts[0].prop;
     this.sortOrder = event.sorts[0].dir;
     this.rerender(false);
   }

   /**
    * Populate the table with new data based on the page number
    * @param page The page to select
    */
   public setPage(pageInfo) {
     this.pageNumber = pageInfo.offset;
     this.rerender(false);
   }
   /**
    * Show number of records in datatable
    * @param value show total entries value 10,25,50,100
    */
   public changeLimit(value) {
     this.size = value;
     this.rerender(true);
   }
   /**
    * API call and refresh datatable value
    * @param goFirstPage set first page when param value true
    */
   private rerender(goFirstPage): void {
     if (goFirstPage) {
       this.pageNumber = 0;
     }
     this.getExtendedOrdersData();
  }

  public getExtendedOrdersData(){    
    this.loadingIndicator = true;
    this.getSuccessResult = false;
    const obj = {
      uuid: this.uuid,
      filter: this.highestValueFilter,
      type: 'users',
      start: (this.pageNumber) * (this.size),
      length: this.size,
      isExtended: true
      // sort_param: this.sortParam,
      // sort_type: this.sortOrder,
    }
    this.dashService.getOrderAnalyticsStats(obj)
    .pipe(first())
    .subscribe(res =>{
      if(this.getSuccessResult == false){
        this.loadingIndicator = false;
        this.getSuccessResult = true;
        this.extendedOrdersData = res.data.users;
        this.totalReords = res.data.total_records;
      }
    },
    (err)=>{
      this.loadingIndicator = false;
    })
  }
  //initial state current filter passing to be done to modal

  public onFilterChange(){
    this.rerender(true);
  }

  openExportModal(template: TemplateRef<any>){
    this.modalRefExport = this.modalService.show(template, { class: 'modal-md modal-dialog-centered',backdrop: 'static' });
    this.reportType = 'default';
    this.exportType = 'csv';
    this.csvClicked = true;
    this.excelClicked = false;
  }

  //update export types - csv or excel
  toggleClick(imageType: string) {
    if (imageType === 'csv') {
      this.csvClicked = true
      this.excelClicked = false;
      this.exportType = 'csv';
    } else if (imageType === 'excel') {
      this.excelClicked = true
      this.csvClicked = false;
      this.exportType = 'excel';
    }
  }

  downloadData() {
    this.req = {
      uuid: this.uuid,
      type: 'users',
      exporttype : this.exportType,
      exportTable : 1,
      filter: this.highestValueFilter,
    }
    this.loader.showLoader();

    this.dashService.getOrderAnalyticsStats(this.req)
      .subscribe(data => {
        this.loader.hideLoader();
      },
      error => {
        this.loader.hideLoader();
        if(this.req.exporttype == 'excel'){
          const blob = new Blob([error.text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url= window.URL.createObjectURL(blob);
          saveAs(url, `${this.fileName}.xls`);
        }else{
          const blob = new Blob([error.text], { type: 'text/csv;charset=utf-8;' });
          const url = window.URL.createObjectURL(blob);
          saveAs(url, `${this.fileName}`);
        }
        this.declined();
      },
      () => console.log('OK'));
  } 

  declined(): void {
    this.modalRefExport.hide();
  }

  decline(): void {
    this.modalRef.hide();
  }

}
